import { useState, useEffect } from 'react'

const TIP_PREFIX = 'pantry-tip-seen-'

export function useTip(tipId: string) {
  const key = TIP_PREFIX + tipId
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const seen = localStorage.getItem(key)
    if (!seen) setVisible(true)
  }, [key])

  function dismiss() {
    localStorage.setItem(key, '1')
    setVisible(false)
  }

  return { visible, dismiss }
}
